<template>
  <div>
    <a-card>
      <span slot="title">Master Kalender</span>
      <!-- <div v-if="!isMobile" slot="extra" class="d-flex flex-row">
        <a-input-search v-model="search" placeholder="Pencarian ... " class="m-right"/>

      </div>
      <div v-else class="d-flex flex-row m-bottom">
        <a-input-search v-model="search" placeholder="Pencarian ... " class="m-right"/>
        <a-button class="m-right" type="primary" icon="plus" />

      </div> -->


      <vc-calendar
        locale="id"
        is-expanded
        @dayclick="dayclick"
        :isInteractive="true"
        :attributes='monthYearSelected'
        @update:to-page="toPage"
      >
      </vc-calendar>
      <br/>

      <a-list item-layout="horizontal" :data-source="monthYearSelected" v-if="isMobile">
        <a-list-item slot="renderItem" slot-scope="item">
<!--          <a-icon slot="actions" type="edit" @click="editActionList(item)"/>-->
<!--          <a-icon slot="actions" type="close" />-->
          <a-list-item-meta >
              <a-row slot="title" type="flex" justify="space-between">
                <a-tag  :color="item.customData.color">{{item.customData.kategori_nm}}</a-tag>
                <a class="vc-text-gray-900">{{moment(item.dates[0]).format(getDefaultDateFormat)}}
                </a>
            </a-row>
            <br/><a-badge slot="avatar" :color="item.customData.color"/>
            <a slot="description" class="vc-text-gray-900">{{ item.customData.description }}</a>
            <a slot="description" v-if="item.customData.remark"><br/>*{{ item.customData.remark }}</a>
          </a-list-item-meta>
        </a-list-item>
      </a-list>

      <a-list item-layout="horizontal" :data-source="monthYearSelected" v-else>
        <a-list-item slot="renderItem" slot-scope="item">
<!--          <a-icon slot="actions" type="edit" @click="editActionList(item)"/>-->
<!--          <a-icon slot="actions" type="close" />-->
          <a-list-item-meta >
              <a-row slot="title" type="flex" justify="space-between">
                  <a class="vc-text-gray-900">{{moment(item.dates[0]).format(getDefaultDateFormat)}}
                </a>
                <a-tag  :color="item.customData.color">{{item.customData.kategori_nm}}</a-tag>
            </a-row>
            <br/><a-badge slot="avatar" :color="item.customData.color"/>
            <a slot="description" class="vc-text-gray-900">{{ item.customData.description }}</a>
            <a slot="description" v-if="item.customData.remark"><br/>*{{ item.customData.remark }}</a>
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-card>

    <a-drawer
      :title="contentDayClick.label"
      :visible="visibleDraw"
      :placement="isMobile ? 'bottom' : 'right' "
      :height="isMobile ? 720 : '' "
      :width="isMobile ? 256 : 500"
      @close="handleCancel"
      :destroyOnClose="true"
    >

      <a-form :form="form" layout="vertical" hide-required-mark>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="Tanggal / Event">
              <a-date-picker
                v-decorator="['dates', {rules: [{required: true}],initialValue: modeEntri==='create' ?  moment(contentDayClick.date, getStandartFormatDate) : moment(tempDayTableData.dates[0],getStandartFormatDate)}]"
                :format="getDefaultDateFormat"
                allowClear :disabled="modeEntri === 'create'? true:false"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="Jenis">
              <a-select showSearch  placeholder="Pilih Jenis" :filterOption="filterOption" allowClear @change="handleJenisChange" v-decorator="['kategori_nm', {rules: [{required: true}],initialValue: tempDayTableData.kategori_nm}]">
                <a-select-option v-for="item in kategori_nm" :key="item.value">{{item.value}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <!-- <a-form-item label="Kategori">
              <a-select showSearch allowClear :filterOption="filterOption" v-decorator="['kategori', {rules: [{required: true}],initialValue: tempDayTableData.kategori_id}]">
                <a-select-option v-for="item in (choicedJenis ==='' ? tempKategori : choicedKategori) " :key="item.kategori_id">{{item.nama_kategori}}
                </a-select-option>
              </a-select>
            </a-form-item> -->
            <a-form-item label="Information">
              <a-input
                v-decorator="['info',{rules: [{ required: true}],initialValue: tempDayTableData.description},]" placeholder="Informasi"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="Description">
              <a-input
                v-decorator="['remark',{rules: [{ required: false}],initialValue: tempDayTableData.remark},]" placeholder="Keterangan"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Repeat year">
         <a-checkbox @change="onChange" :checked="checkValue">
            Check untuk diulang setiap tahun
         </a-checkbox>
        </a-form-item>
        <div
          :style="{

          right: 0,
          bottom: 0,
          width: '100%',
          borderBottom: '1px solid #e9e9e9',
          paddingBottom: '10px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
        >
          <a-button :style="{ marginRight: '8px' }" @click="onReset">
            Reset
          </a-button>
          <a-button type="primary" v-if="modeEntri === 'create' " @click="handleSubmit">
            Submit
          </a-button>
          <a-button type="primary" v-else @click="handleUpdate">
            Update
          </a-button>
        </div>
      </a-form>

      <br/>

      <a-list item-layout="horizontal" :data-source="dayTableData">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-icon slot="actions" type="edit" @click="editActionList(item)"/>
          <a-icon slot="actions" type="close" @click="handleDelete(item)"/>
          <a-list-item-meta >
            <a slot="title" >{{ item.description }}</a>
            <a-badge slot="avatar" :color="item.color"/>
            <br/>
            <div slot="description">
              <span >{{moment(item.dates[0]).format(getDefaultDateFormat)}}</span>
              <br/>
              <a-tag  :color="item.color">{{item.kategori_nm}}</a-tag>
            </div>
          </a-list-item-meta>
        </a-list-item>
      </a-list>

    </a-drawer>
  </div>
</template>


<script>
    import axios from "axios";
    import {mapGetters} from "vuex";
    import moment from "moment";

    const columns = [
        {
            title: 'Description',
            dataIndex: 'description',
            width: '25%',
            scopedSlots: {customRender: 'description'},
            visible: false
        },
        {
            title: 'Category',
            dataIndex: 'category',
            width: '40%',
            scopedSlots: {customRender: 'category'},
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            scopedSlots: {customRender: 'operation'},
        },
    ];

    export default {
        name: "M.Kalender",
        data() {
            return {
                search: "",
                visible: false,
                contentDayClick: {},
                dayTableData: [],
                columns,
                editingKey: '',
                monthYearSelected: [],
                dataDateMonth: [],
                dateNow: null,
                cacheData : {},
                kategori : [],
                kategori_nm : [],
                visibleDraw : false,
                form: this.$form.createForm(this),
                tempDayTableData : [],
                choicedkategori_nm : '',
                tempKategori : [{kategori_id:'x',nama_kategori: ''}],
                choicedKategori : [],
                modeEntri : 'create',
                checkValue : false,
            };
        },
        computed: {
            ...mapGetters(["getAuth", "getStandartFormatDate","getDefaultDateFormat"]),

        },
        created(){
            this.fetchData();
        },
        mounted() {
            Event.$on("confirmMessageReturn", this.handleSubmitProcess);
            Event.$on("confirmMessageEdit", this.handleEditProcess);
            Event.$on("confirmMessageDelete", this.handleDeleteProcess);
        },
        beforeDestroy() {
            Event.$off("confirmMessageReturn", this.handleSubmitProcess);
            Event.$off("confirmMessageEdit", this.handleEditProcess);
            Event.$off("confirmMessageDelete", this.handleDeleteProcess);
        },
        methods: {
            moment,
            btnDeleteEvent() {
                console.log('dlete')
            },
            btnEditEvent() {
                console.log('edit')
                this.visible = true;
            },
            handleCancel() {
                this.dayTableData.forEach(function(v){ delete v.editable });
                this.dayTableData = [];
                this.editingKey = "";


                this.form.resetFields();
                this.modeEntri = 'create'
                this.tempDayTableData = [];
                this.visibleDraw = false;



            },
            dayclick(day) {
                this.contentDayClick = {label : day.ariaLabel, date : day.id};
                if (day.attributes) {
                    day.attributes.map((item, index) => {
                        item.customData.key = index
                        this.dayTableData.push(item.customData);
                    })
                }

                this.cacheData = this.dayTableData.map(item => ({ ...item }));

                // this.dayTableData = day.attributes;

                this.checkValue = false;
                this.visibleDraw = true;
            },
            edit(key) {
                const newData = [...this.dayTableData];
                const target = newData.filter(item => key === item.key)[0];
                this.editingKey = key;
                if (target) {
                    target.editable = true;
                    this.dayTableData = newData;
                }
            },
            toPage(page) {
                this.getMonthYear(page)
            },
            getMonthYear(data) {
                axios({
                    method: "get",
                    url: this.$serviceUrl + "kalender",
                    headers: {
                        "X-API-KEY": this.getAuth.apikey
                    },
                    params: {
                        tlc: this.tlc,
                        bln: data.month,
                        thn: data.year
                    },
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password
                    }
                })
                    .then(response => {
                        // console.log('data yang di pilih');
                        // this.dataDateMonth = response.data;
                        // console.log(response);

                        this.monthYearSelected = response.data.data.map(todo => ({

                            dates: todo.dates,
                            dot: {
                                color: todo.color,
                                class: todo.isComplete ? 'opacity-75' : '',
                            },
                            // We need to at least pass a truthy value for the popover to appear
                            // Pass an object to customize popover settings like visibility, placement, etc.
                            popover: false,
                            customData: todo,
                        }));


                    })
                    .catch(err => {
                        // console.log(err.response);
                        this.monthYearSelected = [];
                        // this.dataDateMonth = err.data.data
                    });
            },
            cancel(key){
                const newData = [...this.dayTableData];
                const target = newData.filter(item => key === item.key)[0];
                this.editingKey = '';
                if (target) {
                    Object.assign(target, this.cacheData.filter(item => key === item.key)[0]);
                    delete target.editable;
                    this.dayTableData = newData;
                }

            },
            // "kalender/jenis_kategori
            // kalender/kategori
            async fetchData(){
                const jns_kategori = await axios.get(
                    this.$serviceUrl + "kalender/jenis_kategori",
                    {
                        auth: {
                            username: this.getAuth.username,
                            password: this.getAuth.password
                        },
                        headers: {
                            "X-API-KEY": this.getAuth.apikey
                        },
                    }
                );

                // const kategori = await axios.get(
                //     this.$serviceUrl + "kalender/kategori",
                //     {
                //         auth: {
                //             username: this.getAuth.username,
                //             password: this.getAuth.password
                //         },
                //         headers: {
                //             "X-API-KEY": this.getAuth.apikey
                //         },
                //     }
                // );

                Promise.all([jns_kategori]).then(
                    response => {
                        this.kategori_nm = response[0].data.data;
                        // let tempKategori = response[1].data.data;

                        // let grouped = _.mapValues(_.groupBy(tempKategori, 'jenis_kategori'),
                        //     clist => clist.map(kate => _.omit(kate, 'jenis_kategori')));

                        // this.kategori = grouped;

                    }
                );
            },
            editActionList(item){
                this.form.resetFields();
                this.choicedkategori_nm = item.kategori_nm;

                this.tempDayTableData = item;
                this.tempDayTableData.kategori_nm = item.kategori_nm;
                this.checkValue = item.repeat=="1" ? true : false;
                this.modeEntri = 'update';
            },
            handleJenisChange(item){
                this.choicedkategori_nm = item;

            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            onReset(){
                this.modeEntri = 'create'
                this.tempDayTableData = [];
                this.form.resetFields();
                this.checkValue = false;
            },
            handleSubmitProcess(){
                this.form.validateFields((err, values) => {
                    if (err) {
                        return;
                    }
                    let postData = new FormData();
                    postData.append("tanggal_kalender", moment(values.dates, this.getDefaultDateFormat).format(this.getStandartFormatDate));
                    // postData.append("kategori_id", values.kategori);
                    postData.append("tlc", this.getAuth.username);
                    postData.append("info", values.info);
                    postData.append("remark", values.remark);
                    postData.append("kategori_nm", values.kategori_nm);
                    if (this.checkValue){
                        postData.append("repeat", "1");
                    }else{
                        postData.append("repeat", "0");
                    }

                    axios({
                        method: "post",
                        url: this.$serviceUrl + "kalender/create",
                        processData: false,
                        auth: {
                            username: this.getAuth.username,
                            password: this.getAuth.password
                        },
                        headers: {
                            "X-API-KEY": this.getAuth.apikey
                        },
                        data: postData
                    })
                        .then(response => {
                            this.$notification.success({
                                message: "Sukses",
                                description: "Data telah berhasil diproses!"
                            });
                            this.visibleDraw = false;
                            this.$router.go();

                        })
                        .catch(err => {
                            if (err.response.data.status === false) {
                                this.$notification.error({
                                    message: "Error",
                                    description: err.response.data.message
                                });
                            }
                        });

                });


            },
            handleDeleteProcess(item){
                axios({
                    method: "post",
                    url: this.$serviceUrl + "kalender/delete",
                    processData: false,
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password
                    },
                    headers: {
                        "X-API-KEY": this.getAuth.apikey
                    },
                    data: {kalender_id  : item.kalender_id}
                })
                    .then(response => {
                        this.$notification.success({
                            message: "Sukses",
                            description: response.data.message
                        });
                        // this.fetchData();
                        this.visibleDraw = false;
                        this.$router.go();
                    })
                    .catch(err => {
                        if (err.response.data.status === false) {
                            this.$notification.error({
                                message: "Error",
                                description: err.response.data.message
                            });
                        }
                    });
            },
            handleEditProcess(){
                this.form.validateFields((err, values) => {
                    if (err) {
                        return;
                    }
                    let postData = new FormData();
                    postData.append("tanggal_kalender", moment(values.dates, this.getDefaultDateFormat).format(this.getStandartFormatDate));
                    postData.append("kategori_nm", values.kategori_nm);
                    postData.append("tlc", this.getAuth.username);
                    postData.append("info", values.info);
                    postData.append("remark", values.remark);
                    postData.append("kalender_id", this.tempDayTableData.kalender_id);
                    if (this.checkValue){
                        postData.append("repeat", "1");
                    }else{
                        postData.append("repeat", "0");
                    }

                    axios({
                        method: "post",
                        url: this.$serviceUrl + "kalender/edit",
                        processData: false,
                        auth: {
                            username: this.getAuth.username,
                            password: this.getAuth.password
                        },
                        headers: {
                            "X-API-KEY": this.getAuth.apikey
                        },
                        data: postData
                    })
                        .then(response => {
                            this.$notification.success({
                                message: "Sukses",
                                description: "Data telah berhasil diubah!"
                            });
                            this.visibleDraw = false;
                            this.$router.go();

                        })
                        .catch(err => {
                            if (err.response.data.status === false) {
                                this.$notification.error({
                                    message: "Error",
                                    description: err.response.data.message
                                });
                            }
                        });

                });
            },
            handleSubmit(){
                this.form.validateFields((err, values) => {
                    if (err) {
                        return;
                    }
                this.confirmMessage("confirm-save");
                });
            },
            handleDelete(item){
                this.confirmMessageValue("confirm-delete",item);
            },
            handleUpdate(){
                this.form.validateFields((err, values) => {
                    if (err) {
                        return;
                    }
                this.confirmMessage("confirm-edit");
                });
            },
            onChange(e){
                if (e.target.checked) {
                    this.checkValue = true;
                } else {
                    this.checkValue = false;
                }
            }


        },


    }
</script>
